import { render, staticRenderFns } from "./ExamTrueFalse.vue?vue&type=template&id=47d4810a&"
import script from "./ExamTrueFalse.vue?vue&type=script&lang=js&"
export * from "./ExamTrueFalse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ExamTrueFalse.vue"
export default component.exports